import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';

export default function NotFoundPage() {
  useSeo({
    title: '404 - Siden findes ikke',
    description: 'Den efterspurgte side kunne ikke findes i Skatunderlups arkiv.',
  });

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16">
      <div className="max-w-xl text-center rounded-md border border-slate-200 bg-white p-8 sm:p-12 shadow-xs">
        <span className="font-mono text-xs font-bold uppercase tracking-widest text-[#fd7302]">
          Fejl 404 · Siden er ikke fundet
        </span>
        <h1 className="mt-2 font-serif text-4xl sm:text-5xl font-black text-[#010b27]">
          Siden eksisterer ikke i arkivet
        </h1>
        <div className="my-4 mx-auto h-0.5 w-16 bg-[#fd7302]" />
        <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
          Artiklen, sektionen eller dokumentet, du forsøger at tilgå, er enten flyttet, slettet eller midlertidigt taget af forsiden.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-sm bg-[#fd7302] px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#e06500] transition-colors"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til Forsiden</span>
          </Link>
          <Link
            to="/artikler"
            className="inline-flex items-center gap-2 rounded-sm border border-[#010b27] bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-[#010b27] hover:bg-[#010b27] hover:text-white transition-colors"
          >
            <i className="fa-solid fa-newspaper text-xs" aria-hidden="true" />
            <span>Søg i artikler</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
